export default "__VITE_ASSET__BCoxTMEh__";